export const ru = {
  header: {
    title: 'Доктор Хоштария',
  },
  nav: {
    about: 'О нас',
    services: 'Услуги',
    education: 'Образовательные ресурсы',
    askDoctor: 'Спросить Доктора',
    contact: 'Контакты'
  },
  education: {
    title: 'Образовательные ресурсы',
    subtitle: 'Подборка видеоматериалов для лучшего понимания женского здоровья',
    georgian: {
      title: 'Образовательные ресурсы на грузинском языке',
      watchVideo: 'Смотреть видео'
    },
    english: {
      title: 'Образовательные ресурсы на английском языке',
      watchVideo: 'Смотреть видео'
    },
    russian: {
      title: 'Образовательные ресурсы на русском языке',
      watchVideo: 'Смотреть видео'
    }
  },
  hero: {
    title: 'Доктор Мамука Хоштария',
    subtitle: 'Признанный акушер-гинеколог с более чем 40-летним опытом в области женского здоровья',
    cta: 'Записаться на прием',
  },
  stats: {
    childbirths: {
      number: '20,000+',
      text: 'Успешных родов',
    },
    complications: {
      number: '2,000+',
      text: 'Сложных случаев',
    },
    surgeries: {
      number: '3,000+',
      text: 'Сложных операций',
    },
    experience: {
      number: '40+',
      text: 'Лет опыта',
    },
  },
  expertise: {
    title: 'Экспертиза и специализации',
    subtitle: 'С многолетним опытом в акушерстве и гинекологии, доктор Хоштария успешно провел тысячи случаев, от рутинных родов до сложных хирургических процедур.',
    services: {
      obstetrics: {
        title: 'Акушерская помощь',
        description: 'Комплексная помощь при беременности, от пренатального до постнатального обслуживания, с опытом ведения как рутинных, так и беременностей высокого риска.',
      },
      surgery: {
        title: 'Гинекологическая хирургия',
        description: 'Специализация на сложных гинекологических процедурах, включая онкологические и урогинекологические операции.',
      },
      health: {
        title: 'Женское здоровье',
        description: 'Комплексные услуги по охране женского здоровья на всех этапах жизни.',
      },
      additional: {
        title: 'Дополнительные услуги',
        description: 'Специализированные услуги, включая лечение бесплодия, малоинвазивные процедуры и профилактические консультации.',
      },
    },
  },
  contact: {
    title: 'Контактная информация',
    subtitle: 'Запишитесь на прием или свяжитесь с нами по любым вопросам.',
    getInTouch: 'Свяжитесь с нами',
    mobile: 'Мобильный',
    office: 'Офис',
    currentWorkplaces: 'Текущие места работы',
    phone: '+995 599 43 66 77',
    landline: '+995 032 2 52 05 25',
    email: 'mamuka_khoshtaria@yahoo.com',
    clinics: {
      openHeart: 'Открытое Сердце - Университетская Клиника',
      barbara: 'Клиника Репродуктивного Здоровья Барбаре'
    },
    hours: 'Понедельник - Пятница: 9:00 - 18:00',
    appointments: 'Доступна запись на прием',
  },
  footer: {
    copyright: '© {year} Доктор Мамука Хоштария. Все права защищены.',
  },
  aiChat: {
    title: 'AI Медицинский Ассистент',
    backToHome: 'Вернуться на главную',
    description: 'Этот AI ассистент поможет вам с:',
    capabilities: {
      general: 'Общая медицинская информация и рекомендации',
      symptoms: 'Распространенные симптомы и состояния',
      recommendations: 'Базовые рекомендации по здоровью',
      pregnancy: 'Информация о беременности и женском здоровье'
    },
    disclaimer: 'Обратите внимание: AI предоставляет только общую информацию и не заменяет профессиональную медицинскую консультацию.',
    askDoctor: {
      title: 'Задать вопрос доктору Хоштария',
      description: 'Есть конкретный вопрос для доктора Хоштария? Оставьте свой вопрос здесь, и доктор лично рассмотрит и ответит на ваш запрос в рабочее время. Вы также можете прикрепить соответствующие медицинские документы, чтобы помочь доктору лучше понять вашу ситуацию.',
      instructions: {
        title: 'Как задать вопрос',
        steps: 'Укажите вашу контактную информацию\nНапишите ваш медицинский вопрос подробно\nПрикрепите соответствующие медицинские документы (необязательно)\nОтправьте вопрос и ждите ответа по электронной почте'
      },
      attachments: {
        title: 'Сопроводительные документы',
        description: 'Вы можете прикрепить соответствующие медицинские документы:',
        voice: {
          title: 'Голосовая запись',
          description: 'Вы можете записать свой голос, чтобы подробно объяснить свой вопрос',
          start: 'Начать запись',
          stop: 'Остановить запись',
          delete: 'Удалить запись',
          duration: 'Продолжительность записи: {seconds} секунд',
          instructions: 'Нажмите, чтобы начать запись голосового сообщения. Говорите четко и подробно опишите вашу медицинскую проблему.',
          processing: 'Обработка...',
          error: 'Ошибка записи',
          tryAgain: 'Пожалуйста, попробуйте записать ещё раз.',
          recordedLabel: 'Голосовое сообщение записано'
        },
        types: 'Результаты лабораторных анализов\nЗаключения по медицинским снимкам\nПредыдущие медицинские записи\nДокументы рецептов',
        limits: 'Принимаемые форматы: Изображения, PDF, DOC. Максимальный размер: 10МБ на файл',
        button: 'Добавить документы',
        remove: 'Удалить',
        subtitle: 'Результаты анализов и медицинские документы помогут доктору ответить точнее',
        note: 'До 30 файлов, до 10МБ каждый. Текст из PDF и Word извлекается автоматически.',
        processingCount: 'Обработка {count} файл(ов)...',
        uploadingTitle: 'Загрузка файлов',
        inProgress: 'В обработке: {count} файл(ов)',
        pleaseWait: 'Пожалуйста, подождите, ваши файлы обрабатываются...',
        listTitle: 'Прикреплённые файлы',
        counter: '{current}/{max} файлов',
        processingShort: 'Обработка...',
        pageProgress: 'Страница {current} из {total}',
        timeRemaining: 'осталось {time}',
        extractedOk: 'Текст извлечён ({pages} стр., {chars}k символов)',
        previewLabel: 'Предпросмотр извлечённого текста:',
        imageReady: 'Изображение готово ({size} МБ)',
        fileReady: 'Готово ({size} МБ)',
        errorLabel: 'Ошибка',
        methodOcr: 'OCR',
        methodStandard: 'ТЕКСТ'
      },
      emailNote: 'Вы получите ответ по электронной почте',
      contact: {
        title: 'Контактная информация',
        subtitle: 'Ответ доктора придёт на вашу электронную почту'
      },
      questionHint: 'Опишите вашу проблему как можно подробнее — или запишите голосовое сообщение ниже',
      orSpeak: 'или запишите голосовое сообщение',
      optionalTag: 'необязательно',
      namePlaceholder: 'Ваше имя',
      emailPlaceholder: 'Ваш email',
      phonePlaceholder: 'Телефон (необязательно)',
      label: 'Ваш вопрос',
      placeholder: 'Введите ваш медицинский вопрос здесь...',
      submit: 'Отправить вопрос',
      submitSaving: 'Сохраняем ваш вопрос…',
      submitUploading: 'Загружаем вложения…',
      error: 'При отправке вопроса произошла ошибка. Пожалуйста, попробуйте еще раз.',
      success: {
        title: 'Спасибо за ваш вопрос!',
        message: 'Доктор Хоштария рассмотрит и ответит на ваш запрос по электронной почте как можно скорее.',
        askAnother: 'Задать другой вопрос'
      }
    }
  },
  askDoctor: {
    form: {
      namePlaceholder: 'Ваше имя',
      emailPlaceholder: 'Ваш email'
    }
  },
  chat: {
    title: 'AI Медицинский Ассистент',
    subtitle: 'Получите экспертные медицинские консультации 24/7',
    disk: {
      medicalAssistance: 'Медицинская Помощь',
      healthGuidance: 'Советы по Здоровью',
      expertSupport: 'Поддержка Эксперта',
      available: 'Доступно 24/7'
    },
    welcome: 'Задайте любые медицинские вопросы, основанные на опыте доктора Хоштария',
    placeholder: 'Введите ваш вопрос здесь...',
    error: 'Извините, но возникли проблемы с подключением. Пожалуйста, попробуйте еще раз.',
    online: 'Онлайн',
    typing: 'Печатает...',
    thinking: 'Думает...',
    sources: 'Источники',
    reasoning: {
      label: 'Глубокий анализ',
      tooltip: 'Когда включено, ассистент рассуждает глубже и ищет в интернете для лучших ответов.',
      on: 'Вкл.',
      off: 'Выкл.'
    },
    inputAriaLabel: 'Ввод сообщения',
    sendAriaLabel: 'Отправить сообщение',
    sectionTitle: 'AI Ассистент',
    sectionSubtitle: 'Используйте AI чат-бот для ответов на частые вопросы',
    quickReplies: {
      appointments: 'Как записаться на прием?',
      services: 'Какие услуги вы предоставляете?',
      location: 'Где находится ваша клиника?'
    },
    actions: {
      newChat: 'Новый чат',
      history: 'История чатов',
      collapse: 'Свернуть чат',
      attach: 'Прикрепить файлы',
      remove: 'Удалить файл',
      editSend: 'Редактировать и отправить'
    },
    history: {
      title: 'История чатов',
      back: 'Назад к чату',
      empty: 'Предыдущие беседы не найдены',
      view: 'Открыть',
      delete: 'Удалить',
      confirmDelete: 'Удалить эту беседу? Это действие нельзя отменить.',
      loadFailed: 'Не удалось загрузить беседы',
      deleteFailed: 'Не удалось удалить беседу'
    },
    attachment: {
      preview: 'Извлечённый текст',
      extracted: 'Текст извлечён',
      pages: 'стр.',
      page: 'Страница',
      error: 'Ошибка'
    },
    voice: {
      start: 'Записать голосовое сообщение',
      stop: 'Остановить запись',
      noSpeech: 'Речь в записи не обнаружена. Пожалуйста, попробуйте ещё раз.',
      failed: 'Не удалось расшифровать запись.'
    },
    editForm: {
      title: 'Редактировать и отправить ответ AI',
      emailLabel: 'Email пациента *',
      phoneLabel: 'Телефон пациента',
      questionLabel: 'Исходный вопрос',
      originalLabel: 'Исходный ответ AI',
      responseLabel: 'Редактировать ответ *',
      emailPlaceholder: 'Введите email пациента',
      phonePlaceholder: 'Введите телефон пациента',
      questionPlaceholder: 'Введите исходный вопрос',
      responsePlaceholder: 'Отредактируйте ответ AI здесь...',
      downloadPdf: 'Скачать PDF',
      cancel: 'Отмена',
      send: 'Отправить пациенту',
      sending: 'Отправка...'
    }
  },
  admin: {
    nav: {
      backToHome: 'На главную',
      chatHistory: 'История чата',
      logout: 'Выйти'
    },
    aiAssistant: {
      title: 'AI-ассистент',
      subtitle: 'Используйте AI-чатбот для ответов на частые вопросы'
    },
    questions: {
      title: 'Вопросы пациентов',
      subtitle: 'Управляйте обращениями пациентов и отвечайте на них',
      filterAll: 'Все вопросы',
      filterPending: 'В ожидании',
      filterAnswered: 'Отвеченные',
      statusAnswered: 'Отвечено',
      statusPending: 'В ожидании',
      newReply: 'Новый ответ',
      questionPreviewLabel: 'Вопрос',
      respond: 'Ответить',
      pdf: 'PDF',
      delete: 'Удалить',
      questionDetails: 'Детали вопроса',
      patientQuestion: 'Вопрос пациента',
      aiInitialResponse: 'Первоначальный ответ AI',
      yourResponse: 'Ваш ответ',
      generatedAt: 'Сгенерировано: {date}',
      sentAt: 'Отправлено: {date}',
      voiceMessage: 'Голосовое сообщение',
      durationSeconds: 'Длительность: {seconds} сек.',
      attachments: 'Вложения',
      answeredOn: 'Отвечено: {date}',
      emptyTitle: 'Вопросов пока нет',
      emptyMessage: 'Обращения пациентов появятся здесь после их отправки.',
      errorTitle: 'Ошибка',
      previewDownload: 'Скачать',
      confirmDelete: 'Вы уверены, что хотите удалить этот вопрос? Это действие нельзя отменить.',
      responseSent: 'Ответ успешно отправлен!'
    },
    respondForm: {
      title: 'Ответить пациенту',
      patientQuestionLabel: 'Вопрос пациента',
      aiResponseLabel: 'Ответ, сгенерированный AI',
      yourResponseLabel: 'Ваш ответ',
      responsePlaceholder: 'Отредактируйте или напишите ответ здесь...',
      downloadPdf: 'Скачать PDF',
      cancel: 'Отмена',
      send: 'Отправить ответ',
      sending: 'Отправка...'
    }
  },
};